import { dateFNS, fromTimeZoneToUTC, toISOString } from '@gogame/intl-ts';
import { object, string, number, collection } from '@gogame/schemas';

import { OWNERS, OWNER_ID, PERIOD_START_DATE } from './constants';

export const ownerSchema = object({
  [OWNER_ID]: number().required('Owner is required'),
  [PERIOD_START_DATE]: string().default('').required(),
});

export const ownersSchema = collection(ownerSchema).default([
  ownerSchema.default(),
]);

export const managementSchema = object({
  [OWNERS]: ownersSchema,
});

const toISO = (value) => toISOString(fromTimeZoneToUTC(value));

export function createNewOwner(prevPeriodDate) {
  return prevPeriodDate
    ? ownerSchema.cast(
        {
          [PERIOD_START_DATE]: prevPeriodDate
            ? toISO(
                dateFNS.startOfDay(dateFNS.addDays(new Date(prevPeriodDate), 1))
              )
            : undefined,
          [OWNER_ID]: -1,
        },
        { context: {} }
      )
    : ownerSchema.default();
}
